var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VContainer',{attrs:{"fluid":""}},[_c('div',{staticClass:"d-flex justify-space-between align-end"},[_c('span',{staticClass:"font-weight-negrita",class:_vm.$vuetify.breakpoint.mdAndUp ? 'headline' : 'title'},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }